// extracted by mini-css-extract-plugin
export default {"floating-button-section":"floating-button-section_floating-button-section__ztRqt"};